import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { useLanguage } from "../contexts/LanguageContext";
import { translate } from "../translations";

function MasterSudokuChallengeLanding() {
  const { language } = useLanguage();

  return (
    <>
      <Header />
      <div
        className="msc-landing"
        style={{
          padding: "32px",
          maxWidth: 700,
          margin: "0 auto",
          textAlign: "center",
        }}
      >
        <div className="header-fill"></div>
        <h1>{translate("masterSudokuTitle", language)}</h1>
        <p style={{ fontSize: "1.15em", margin: "24px 0" }}>
          {translate("masterSudokuDescLong", language)}
        </p>
        <a
          href={`mailto:support@ygalaad.com?subject=${encodeURIComponent(
            translate("masterSudokuTitle", language) +
              " - " +
              (language === "fr" ? "Contact" : "Contact")
          )}`}
          className="menu-link"
        >
          {translate("contactSupport", language)}
        </a>
      </div>
      <Footer />
    </>
  );
}

export default MasterSudokuChallengeLanding;
